document.addEventListener('DOMContentLoaded', function() {
    const labels = document.querySelectorAll('.wc-bookings-date-picker-date-fields label');
    if (labels.length >= 2) {
        const firstLabel = labels[0];
        const secondLabel = labels[1];
        const slashNode = firstLabel.nextSibling; // Assuming the "/" is a text node immediately after the first label
        secondLabel.parentNode.insertBefore(firstLabel, secondLabel.nextSibling);
        if (slashNode && slashNode.nodeType === Node.TEXT_NODE && slashNode.nodeValue.trim() === "/") {
            secondLabel.parentNode.insertBefore(slashNode, secondLabel.nextSibling);
        }
    }
});


const topMenu = document.getElementById('top-menu');
const wpMenuCartLi = document.getElementById('wpmenucartli');

if (topMenu && wpMenuCartLi) {
    const firstChild = topMenu.firstElementChild;
    if (firstChild) {
        topMenu.insertBefore(wpMenuCartLi, firstChild.nextSibling);
    } else {
        topMenu.appendChild(wpMenuCartLi);
    }
}




document.addEventListener('DOMContentLoaded', function() {
    const gformFields1 = document.getElementById('gform_fields_1');
    if (gformFields1) {
        const field_1_3 = document.getElementById('field_1_3');
        const field_1_4 = document.getElementById('field_1_4');
        const field_1_5 = document.getElementById('field_1_5');
        const field_1_6 = document.getElementById('field_1_6');
        const field_1_7 = document.getElementById('field_1_7');
        
        if (field_1_3 && field_1_5 && field_1_6) {
            const newRow = document.createElement('div');
            newRow.className = 'row';
            
            const col1 = document.createElement('div');
            col1.className = 'col-md-6 gfmc-column';
            
            const col2 = document.createElement('div');
            col2.className = 'col-md-6';
            
            // Move field_1_6 into col1
            col1.appendChild(field_1_3);
            col1.appendChild(field_1_5);
            col1.appendChild(field_1_6);
            
            // Move field_1_7 into col2
            col2.appendChild(field_1_7);
            
            // Append columns to the new row
            newRow.appendChild(col1);
            newRow.appendChild(col2);
            
            // Append the new row to gformFields1
            gformFields1.appendChild(newRow);
        }
    }
});


jQuery(document).on("em_booking_complete", function(event, response) {
    console.log("Booking complete event triggered");

    // Optional: check for success before redirecting
    if ((response && response.result) || response.success) {
        console.log("Redirecting to review booking...");
        window.location.href = "/review-booking/";
    } else {
        console.warn("Booking failed or response format unexpected");
    }
});


(function( $ ) {

function isGoogleMapsReady() {
    return typeof window.google !== 'undefined' &&
        window.google &&
        window.google.maps;
}

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    if ( ! isGoogleMapsReady() ) {
        return null;
    }

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    if ( ! isGoogleMapsReady() ) {
        return;
    }

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    if ( ! isGoogleMapsReady() || ! map ) {
        return;
    }

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    if ( ! isGoogleMapsReady() ) {
        return;
    }

    $('.acf-map').each(function(){
        initMap( $(this) );
    });
});

})(jQuery);